import {
  Album,
  AnyFeedItemEntityVersion,
  FeedItemMetadata,
  ServiceProvider,
  StorageItem,
  User,
} from '@uploadcam/common';
import { CollectionReference, Timestamp, addDoc } from 'firebase/firestore';
import invariant from 'tiny-invariant';

interface AddFeedItemData {
  album?: Album;
  folder?: StorageItem;
  driveId?: string;
  file: StorageItem;
  metadata?: FeedItemMetadata;
  provider: ServiceProvider;
  user: User;
}

export class AddFeedItemInteractor {
  constructor(private readonly collection: CollectionReference<AnyFeedItemEntityVersion>) {}

  public async execute(data: AddFeedItemData): Promise<void> {
    invariant(data.user.teamId, 'User must be part of a team');

    const createdAt = this.parseDate(data.metadata?.createdAt);

    await addDoc(this.collection, {
      _version: 0,
      createdAt: Timestamp.fromDate(createdAt),
      uploadedAt: Timestamp.now(),
      driveId: data.driveId,
      fileId: data.file.id,
      fileName: data.file.name,
      folderId: data.folder?.id ?? (null as any),
      folderName: data.folder?.name ?? (null as any),
      albumId: data.album?.id ?? (null as any),
      metadata: data.metadata,
      mime: data.file.mime,
      provider: data.provider,
      teamId: data.user.teamId,
      uploadedBy: data.user.id,
    });
  }

  private parseDate(dateStr?: string): Date {
    const date = dateStr ? new Date(dateStr) : new Date();
    return isNaN(date.getTime()) ? new Date() : date;
  }
}
